import styles from "./styles.module.css";
import { MdFilterList } from "react-icons/md";
import { useEffect, useState } from "react";

export default function Search({ value, onChange }) {
  const [_value, setValue] = useState("");

  useEffect(() => {
    let timeout;
    timeout = setTimeout(() => {
      onChange(_value);
    }, 200);
    return () => {
      clearTimeout(timeout);
    };
  }, [_value]);
  return (
    <div className={styles.searchbox}>
      <input
        className="input"
        value={_value}
        onChange={(e) => setValue(e.target.value)}
        id={styles.searchInput}
        placeholder={"search..."}
      />
      {/* <MdFilterList className={"icon"} /> */}
    </div>
  );
}
